import { render, staticRenderFns } from "./PaymentInicis.vue?vue&type=template&id=68e7cafa&scoped=true&"
import script from "./PaymentInicis.vue?vue&type=script&lang=js&"
export * from "./PaymentInicis.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInicis.vue?vue&type=style&index=0&id=68e7cafa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e7cafa",
  null
  
)

export default component.exports